<template>
  <div>
    <div class="string cardholder">
      <div class="fields two">
        <div class="order-input cardholder income-card-input">
          <input
            :class="props.className"
            type="text"
            :placeholder="props.placeholder"
            @focus="inputFocus"
            @blur="inputBlur"
            v-model.trim="modelValue"
          />
          <transition name="fade" tag="div" mode="out-in">
            <div v-if="isShowSuggestions" class="dropdown">
              <div
                class="dropdown-item"
                @click="onSuggestionClick(props.suggestion)"
                @keyup.space="onSuggestionClick(props.suggestion)"
              >
                <span class="item-value">{{ props.suggestion }}</span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <ValidationView :transition="false" :error-messages="props.errorMessages" />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import ValidationView from '@components/ValidationView.vue'

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  className: {
    type: [Array, String, Object],
    default: '',
  },
  errorMessages: {
    type: Array,
    required: true,
  },
  placeholder: {
    type: String,
    required: true,
  },
  suggestion: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['touchField', 'input'])
const isSuggestionVisible = ref(false)

const modelValue = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('input', val)
  },
})

const isShowSuggestions = computed(() => {
  if (!props.suggestion || !isSuggestionVisible.value) return false

  return modelValue.value ? props.suggestion.startsWith(modelValue.value) : true
})

/**
 * @param {string} suggestion
 */
const onSuggestionClick = suggestion => {
  emit('input', suggestion)
}

const inputBlur = () => {
  emit('blur')

  setTimeout(() => {
    isSuggestionVisible.value = false
  }, 200)
}

const inputFocus = () => {
  isSuggestionVisible.value = true
}
</script>

<style lang="scss" scoped>
.income-card-input {
  position: relative;
}

.dropdown {
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 0;

  overflow: auto;
  display: block;

  width: 100%;
  max-height: 160px;
  margin-top: 10px;

  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 3px;
  box-shadow: 0 5px 8px 0 rgb(0 0 0 / 30%);

  span {
    align-items: center !important;
    justify-content: start !important;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
}

:deep(.dropdown-item) {
  cursor: pointer;

  position: relative;

  display: flex;
  align-items: center;

  width: 100%;
  padding: 5px 10px;

  color: #000;
  word-wrap: break-word;

  transition: background-color 0.3s;

  .item-value {
    font-size: inherit !important;
  }

  &:hover {
    background-color: #eaeaea;
  }
}
</style>
